import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { DoctorListCard, Loading } from '../components';
import DoctorAppointmentModal from '../components/DoctorAppointmentModal';
import { api } from '../services';
import { useSearchParams, Link, useLocation, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';

export const DoctorList = () => {
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [doctorData, setDoctorData] = useState([]);
  const [searchParams] = useSearchParams();
  const [catDesc,setCatDesc] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const handleOpenModal = (doctor) => {
    setSelectedDoctor(doctor);
    if (doctor && doctor.DoctorHesabCode) {
      setShowInfoModal(true);
    } else {
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleCloseInfoModal = () => {
    setShowInfoModal(false);
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const CategoryID = searchParams.get('CategoryID');

      const fetchCategories = async () => {

        try {
          const response = await api.get('home/ShowDoctorCategory?OID=1');
          let data = response.data;
          if (typeof data === 'string') {
            try 
            {
              data = JSON.parse(data);
            } 
            catch (error) {
              console.error('Invalid JSON string:', data);
              return;
            }
          }
          // مرتب‌سازی بر اساس SortOrder
          const sortedData = data.sort((a, b) => a.SortOrder - b.SortOrder);
          // فیلتر کردن بر اساس CategoryId
          const filteredData = sortedData.filter(
            (category) => category.ServiceCategoryID === parseInt(CategoryID)
          );
          setCatDesc(filteredData[0].Description);
          localStorage.setItem('CategoryName',filteredData[0].ServiceCategoryName);
        } catch (error) {
          console.error('Error fetching categories:', error);
        }
      };

      try 
      {

        fetchCategories();
        const response = await api.get(`home/GetDoctorList?OID=1&Category=${CategoryID}`);
        // If the response is a JSON string, parse it to an array
        // const data = JSON.parse(response.data);
        let data = response.data;
        if (typeof data === 'string') 
        {
            try 
            {
              data = JSON.parse(data); // اگر رشته است، به JSON تبدیل کن
            } 
            catch (error) 
            {
              console.error('Invalid JSON string:', data);
              throw new Error('Failed to parse JSON');
            }
        }

        console.log(data);

        // const filterdDate = data.filter((item) => item.Semat === semat);
        setDoctorData(data);
      } 
      catch (error) 
      {
        console.error('Error fetching doctor list:', error);
      }
      finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [searchParams]);

  return (
    <>
      <section className="container mb-5 mt-xl-0 mt-4">
        <div className="row mb-4 mt-2">
          <div className="col-lg-12 path">
            <ul>
              <li>
                <Link className='text-decoration-none' to="/">صفحه اصلی</Link>
                <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
              </li>
              {location.state?.from && (
                <li>
                  <span style={{ cursor: 'pointer' }} onClick={handleBack} className="text-primary">
                    {location.state.from}
                  </span>
                  <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
                </li>
              )}
              <li>
                <span>
                  {searchParams.get('CategoryName')}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 doc_col">
            {/* <div className="d-flex flex-lg-row flex-column search_box pt-3 justify-content-between card btm radius15 mb-3">
              <div className="d-flex flex-row mb-3">
                <div className="Dottedstocol ml-3" />
                <div className="singletitle">
                  <span>مشاهده نتایج</span>
                  <h1 className="text-right">
                    {doctorData.map((item, index) =>
                      index <= '0' ? item.DoctorHesabCode : null,
                    )}
                  </h1>
                </div>
              </div>
              <div className="d-flex flex-row w-25 flex-wrap"> */}
                {/* <div className="pl-2 pt-lg-4 w-100 mb-2">
                  <input
                    className="form-control w-100 bg-light border-0 mb-2"
                    placeholder="جستجو براساس نام پزشک .."
                  />
                </div> */}
                {/* Additional filters can be added here */}
              {/* </div>
            </div> */}
            <div className='card p-3 shadow rounded-3'>
              <h5 className='text-center font-weight-bold font-size-24 p-2 animated-title'>
                  {catDesc}
              </h5>
            </div>
            <ul className="p-0 mt-2">
              {loading ? (
                <Loading />
              ) : (
                Array.isArray(doctorData) && doctorData.length > 0 ? (
                  doctorData.map((doctor) => (
                    <DoctorListCard
                      key={doctor.DoctorID} // استفاده از DoctorID به‌عنوان key
                      doctorImage={doctor.ImageDoctor}
                      doctorName={`${doctor.Fname} ${doctor.Lname}`}
                      doctorRate={4}
                      codenezam={doctor.CodeNezam}
                      doctorSpecialty={doctor.Graduate}
                      doctorSemat={doctor.Semat}
                      DoctorID={doctor.DoctorID}
                      buttonOnClick={() => handleOpenModal(doctor)}
                      buttonLabel={doctor.DoctorHesabCode ? 'اطلاعات بیشتر' : 'نوبت بگیرید'}
                    />
                  ))
                ) : (
                  <li>پزشکی یافت نشد.</li>
                )
              )}
            </ul>
          </div>
        </div>
      </section>

      {selectedDoctor && (
        <DoctorAppointmentModal
          show={showModal}
          handleClose={handleCloseModal}
          doctor={selectedDoctor}
        />
      )}

      {selectedDoctor && (
        <Modal
          show={showInfoModal}
          onHide={handleCloseInfoModal}
          centered
        >
          <div className="modal-header">
            {/* <h5 className="modal-title">اطلاعات پزشک</h5>
            <button type="button" className="close" onClick={handleCloseInfoModal}>
              <span>&times;</span>
            </button> */}
          </div>
          <div className="modal-body text-right">
            <p className="mb-0"></p>
            <p className="font-weight-bold" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedDoctor.DoctorHesabCode) }}></p>
          </div>
          <div className="modal-footer">
            <Button variant="secondary" onClick={handleCloseInfoModal}>بستن</Button>
          </div>
        </Modal>
      )}
    </>
  );
};
